import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./warning.svg?react";

export const WarningIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
